"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLandingPageProductsPayload = buildLandingPageProductsPayload;
exports.attachLandingPageProductsPayload = attachLandingPageProductsPayload;
function buildLandingPageProductsPayload(landingPageLinks, cartUpsells, sectionLandingPageLinks) {
    const products = {};
    for (const link of [
        ...landingPageLinks,
        ...cartUpsells,
        ...sectionLandingPageLinks,
    ]) {
        if (products[link.linkHash] == null) {
            products[link.linkHash] = link;
        }
    }
    return {
        products,
        landingPageLinkHashes: landingPageLinks.map((link) => link.linkHash),
        cartUpsellHashes: cartUpsells.map((link) => link.linkHash),
        sectionLandingPageLinkHashes: sectionLandingPageLinks.map((link) => link.linkHash),
    };
}
function attachLandingPageProductsPayload(landingPage) {
    var _a, _b, _c;
    return Object.assign(Object.assign({}, landingPage), buildLandingPageProductsPayload((_a = landingPage.landingPageLinks) !== null && _a !== void 0 ? _a : [], (_b = landingPage.cartUpsells) !== null && _b !== void 0 ? _b : [], (_c = landingPage.sectionLandingPageLinks) !== null && _c !== void 0 ? _c : []));
}
